import { style } from '@vanilla-extract/css'
import { vars, focusRing } from '../design/theme.css'

// The dateline control — prev/next around a big serif date, sized to read as an edition
// marker, not a filter widget (brief §5.5).
export const cal = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: vars.space[3],
})
export const arrow = style({
  appearance: 'none',
  background: 'transparent',
  border: 0,
  cursor: 'pointer',
  color: vars.color.ink2,
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: vars.fs.lg,
  padding: vars.space[1],
  transition: `color ${vars.dur.fast} ease`,
  selectors: {
    '&:hover:not(:disabled)': { color: vars.color.ink },
    '&:disabled': { opacity: 0.3, cursor: 'default' },
    '&:focus-visible': focusRing,
  },
})
export const date = style({ position: 'relative', display: 'inline-flex' })
export const dateBtn = style({
  appearance: 'none',
  background: 'transparent',
  border: 0,
  cursor: 'pointer',
  fontFamily: vars.font.serif,
  fontWeight: 500,
  fontSize: vars.fs.xl,
  lineHeight: 1,
  color: vars.color.ink,
  padding: `0 ${vars.space[1]}`,
  '@media': { 'screen and (max-width: 560px)': { fontSize: vars.fs.lg } },
  selectors: {
    '&:hover': {
      textDecoration: 'underline',
      textUnderlineOffset: vars.uline.mark,
      textDecorationColor: vars.color.rule,
    },
    '&:focus-visible': focusRing,
  },
})
export const native = style({
  position: 'absolute',
  inset: 0,
  opacity: 0,
  width: '100%',
  height: '100%',
  border: 0,
  padding: 0,
  cursor: 'pointer',
})
